import axios from "axios";
import "mathquill/build/mathquill.css";
import { useEffect, useRef, useState } from "react";
import { addStyles, StaticMathField } from "react-mathquill";
import { Link, useNavigate, useParams } from "react-router-dom";
import Back from "../components/button/back";
addStyles();
const latexPattern =
  /\\frac|\\sqrt|\\sum|\\int|\\pi|\\theta|\\alpha|\\beta|\\gamma|\\cdot|\\times|\\left|\\right|\\begin|\\end/;

export const AutoMathText = ({ text }) => {
  if (!text) return null;

  try {
    if (!latexPattern.test(text)) {
      return <span>{text}</span>;
    }

    return (
      <span>
        <StaticMathField>{text}</StaticMathField>
      </span>
    );
  } catch (err) {
    console.error("Math render error:", err);
    return <span>{text}</span>; // fallback aman
  }
};

const AnswerQuestion = () => {
  const submitOnceRef = useRef(false);
  const answersRef = useRef([]);
  const { mapel, questionId } = useParams();
  const [answers, setAnswers] = useState([]);
  const [user, setUser] = useState({});
  const [OptionCorrectAnswer, setOptionCorrectAnswer] = useState({});
  const [Hasil, setHasil] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [hasToken, setHasToken] = useState(false);
  const [essayAnswers, setEssayAnswers] = useState({}); // Menampung jawaban essay per soal
  const [inputValues, setInputValues] = useState([""]);
  const [questionData, setQuestionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [visibilityCount, setVisibilityCount] = useState(0);
  const [examStarted, setExamStarted] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const navigate = useNavigate();

  // const forceSubmit = (reason = "") => {
  //   if (submitOnceRef.current) return;
  //   submitOnceRef.current = true;

  //   // ❌ JANGAN alert
  //   console.warn(reason);

  //   handleSubmit();
  // };

  // const handleSubmitOnce = async (reason = "") => {
  //   if (submitOnceRef.current) return; // ❌ sudah submit, skip
  //   submitOnceRef.current = true; // ✅ tandai sudah submit

  //   if (reason) console.warn(reason); // optional logging
  //   await handleSubmit(); // panggil submit asli
  // };
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const handlePopState = () => {
      if (examStarted && !submitted) {
        safeSubmit("Tombol kembali terdeteksi");
      }
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => window.removeEventListener("popstate", handlePopState);
  }, [examStarted, submitted]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 100);
    const fetchQuestionData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/questions/${questionId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        const qData = response.data;
        setQuestionData(qData);

        // Init answer state
        const initialAnswers = qData.question.map((q, index) => {
          if (q.type === "isian") {
            return {
              text: (inputValues[index] || []).join("|"),
              type: "isian",
              bobot: q.bobot || 1,
              gambar: "",
              keyJawabanBenar: q.keyJawabanBenar,
              optionCorrectAnswer: q.optionCorrectAnswer,
            };
          } else if (q.type === "essay") {
            return {
              text: essayAnswers[index] || "",
              type: "essay",
              bobot: q.bobot || 1,
              gambar: "",
              correctAnswer: q.correctAnswer,
            };
          } else {
            return {
              text: "",
              type: q.type,
              bobot: q.bobot,

              isCorrect: q.isCorrect,
              gambar: "",
            };
          }
        });
        setAnswers(initialAnswers);

        // Set optionCorrectAnswer
        const arrCorrectAnswers = {};
        qData.question.forEach((q, index) => {
          arrCorrectAnswers[index] = (q.optionCorrectAnswer || []).map((a) =>
            a.toLowerCase(),
          );
        });
        setOptionCorrectAnswer(arrCorrectAnswers);
      } catch (err) {
        console.error("Error fetching question:", err);
      }
    };

    const fetchAnswerStatus = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/answers/status/${questionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data.hasSubmitted) {
          setSubmitted(true);
        }
      } catch (error) {
        console.error("Error fetching answer status:", error);
      }
    };

    fetchQuestionData();
    fetchAnswerStatus();
  }, [questionId]); // Hanya mendengarkan perubahan pada `questionId`
  // Hanya mendengarkan perubahan pada `questionId`

  useEffect(() => {
    const fetchQuestionData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/questions/${questionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setQuestionData(response.data);

        // Ambil `OptionCorrectAnswer` untuk setiap soal
        const arrayCorrectAnswers = {};
        response.data.question.forEach((q, index) => {
          arrayCorrectAnswers[index] = q.optionCorrectAnswer.map((answer) =>
            answer.toLowerCase(),
          );
        });
        setOptionCorrectAnswer(arrayCorrectAnswers);
      } catch (error) {
        console.error("Error fetching question data:", error);
      }
    };

    fetchQuestionData();
  }, [questionId]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setHasToken(!!token);

    if (token) {
      axios
        .get(`${process.env.REACT_APP_API_URL}api/auth/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setUser(response.data._id);
        })
        .catch((error) => {
          console.error("Error fetching user profile:", error);
        });
    }
  }, []);

  useEffect(() => {
    const fetchHasil = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/answers/question/${questionId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const dataAnswr = response.data.filter((s) => s.studentId._id === user);
        setHasil(dataAnswr);
        const similarityPromises = dataAnswr.map(async (answer) => {
          const questionComparisons = await Promise.all(
            answer.question.map(async (q, index) => {
              try {
                if (q.type === "isian") {
                  const arrayCorrectAnswers = OptionCorrectAnswer[index] || [];
                  if (!arrayCorrectAnswers.length) {
                    return {
                      ...q,
                      similarity: 0,
                    };
                  }
                  const keyJawabanBenar = q.keyJawabanBenar || 1; // Default jika kosong
                  const userAnswerArray = Array.isArray(q.userAnswer)
                    ? q.userAnswer.map((ans) => ans.trim().toLowerCase())
                    : q.userAnswer
                        ?.split("|")
                        ?.map((ans) => ans.trim().toLowerCase()) || [];

                  const intersectionCount = userAnswerArray.filter((userAns) =>
                    arrayCorrectAnswers.includes(userAns),
                  ).length;
                  return {
                    ...q,
                    similarity: (intersectionCount / keyJawabanBenar) * q.bobot, // Persentase kesamaan
                  };
                }

                const correctAnswer = q.correctAnswer || "";
                let userAnswer =
                  typeof q.userAnswer === "string" ? q.userAnswer : "";

                if (!correctAnswer || !userAnswer) {
                  return { ...q, similarity: 0 };
                }

                const mapel = answer.mapel?.toLowerCase();

                const isBindo =
                  mapel === "bahasa indonesia" || mapel === "bindo";
                const isMtk = mapel === "matematika" || mapel === "mtk";

                // Normalisasi HANYA untuk mapel selain Bindo & MTK
                let text1 = correctAnswer;
                let text2 = userAnswer;

                if (!isBindo && !isMtk) {
                  text1 = text1.toLowerCase();
                  text2 = text2.toLowerCase();
                }

                // Tentukan endpoint
                let endpoint = "api/compare";
                if (isBindo) endpoint = "api/compare/bindo";
                else if (isMtk) endpoint = "api/compare/mtk";

                const compareResponse = await axios.post(
                  `${process.env.REACT_APP_API_URL}${endpoint}`,
                  {
                    text1,
                    text2,
                    bobot: q.bobot,
                  },
                  {
                    headers: { Authorization: `Bearer ${token}` },
                  },
                );

                const similarity = compareResponse?.data?.similarity || 0;

                return { ...q, similarity };
              } catch (error) {
                console.error("Error during comparison:", error);
                return { ...q, similarity: 0, isCorrect: 0 };
              }
            }),
          );
          return { ...answer, question: questionComparisons };
        });
        const answersWithSimilarity = await Promise.all(similarityPromises);
        setHasil(answersWithSimilarity);
      } catch (error) {
        console.error("Error fetching answers:", error);
      }
    };
    fetchHasil();
  }, [questionId, user, OptionCorrectAnswer]);

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "hidden" && !submitted) {
        safeSubmit("Keluar tab");
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [submitted]);

  const handleInputChangeIsian = (nomorSoal, index, value) => {
    const updatedInputValues = { ...inputValues };
    const updatedAnswers = [...answers];

    if (!updatedInputValues[nomorSoal]) {
      updatedInputValues[nomorSoal] = [];
    }
    updatedInputValues[nomorSoal][index] = value;

    if (updatedAnswers[nomorSoal].type === "isian") {
      updatedAnswers[nomorSoal] = {
        ...updatedAnswers[nomorSoal], // Menyebarkan properti lain
        text: updatedInputValues[nomorSoal].join("|"), // Gabungkan nilai jika ada beberapa jawaban
      };
    }

    // Update state dengan nilai baru
    setInputValues(updatedInputValues);
    setAnswers(updatedAnswers);
    answersRef.current = updatedAnswers;
  };
  const handleEssayChange = (index, value) => {
    setEssayAnswers((prevState) => ({
      ...prevState,
      [index]: value,
    }));

    const updatedAnswers = [...answers];
    updatedAnswers[index] = {
      ...updatedAnswers[index],
      text: value,
    };
    setAnswers(updatedAnswers);
    answersRef.current = updatedAnswers;
  };
  const handleInputChange = (index, value, isCorrect = false) => {
    const newAnswers = [...answers];

    if (questionData.question[index].type === "multipleChoice") {
      newAnswers[index] = {
        text: value,
        gambar: answers[index].gambar,
        isCorrect,
        type: questionData.question[index].type,
        bobot: questionData.question[index].bobot,
      };
    } else if (questionData.question[index].type === "essay") {
      newAnswers[index] = {
        text: essayAnswers[index],
        type: questionData.question[index].type,
        bobot: questionData.question[index].bobot,
        gambar: answers[index].gambar,
      };
    }

    setAnswers(newAnswers);
    answersRef.current = newAnswers;
  };

  const compareAnswers = async (
    correctAnswer,
    userAnswer,
    bobot,
    token,
    mapel,
  ) => {
    try {
      if (!correctAnswer || !userAnswer) {
        return 0; // Jika salah satu jawaban kosong, langsung return 0
      }

      const mapelLower = mapel.toLowerCase();
      const isBindo =
        mapelLower === "bindo" || mapelLower === "bahasa indonesia";
      const isMtk = mapelLower === "mtk" || mapelLower === "matematika";

      // Normalisasi HANYA untuk mapel selain Bindo & MTK
      let text1 = correctAnswer.trim();
      let text2 = userAnswer.trim();
      if (!isBindo && !isMtk) {
        text1 = text1
          .toLowerCase()
          .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, " ")
          .replace(/\s{2,}/g, " ")
          .trim();
        text2 = text2
          .toLowerCase()
          .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, " ")
          .replace(/\s{2,}/g, " ")
          .trim();
      }

      // Tentukan endpoint sesuai mapel
      let endpoint = "api/compare"; // default
      if (isBindo) endpoint = "api/compare/bindo";
      else if (isMtk) endpoint = "api/compare/mtk";

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${endpoint}`,
        {
          text1,
          text2,
          bobot,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response?.data?.similarity || 0;
    } catch (error) {
      console.error("Error in compareAnswers:", error);
      return 0;
    }
  };

  const safeSubmit = async (reason = "") => {
    if (submitOnceRef.current) return;

    submitOnceRef.current = true; // LOCK LANGSUNG DI AWAL

    console.warn(reason);

    try {
      await handleSubmit();
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    // if (submitOnceRef.current) return;
    // submitOnceRef.current = true;

    if (submitted) return;

    setSubmitted(true);

    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      const removePunctuation = (text) => {
        return text
          .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, " ") // Ganti tanda baca dengan spasi
          .replace(/\s{2,}/g, " ") // Ganti spasi ganda menjadi satu spasi
          .trim();
      };

      const sourceAnswers = answersRef.current.length
        ? answersRef.current
        : answers;

      const normalizedAnswers = sourceAnswers.map((answer, index) => {
        if (answer.type === "isian") {
          return {
            ...answer,
            text: answer.text || "",
          };
        }

        if (answer.type === "essay") {
          return {
            ...answer,
            text: answer.text || "",
          };
        }

        // multiple choice sudah aman
        return answer;
      });

      const combinedAnswers = await Promise.all(
        normalizedAnswers.map(async (answer) => {
          let mappedCorrectAnswers = "";
          let similarity = 0;

          const mapelLower = mapel.toLowerCase();
          const isBindo =
            mapelLower === "bindo" || mapelLower === "bahasa indonesia";
          const isMtk = mapelLower === "mtk" || mapelLower === "matematika";

          if (answer.type === "isian") {
            const arrayCorrectAnswers = (answer.optionCorrectAnswer || []).map(
              (ans) =>
                isBindo || isMtk
                  ? ans.trim()
                  : removePunctuation(ans.toLowerCase()),
            );

            mappedCorrectAnswers = arrayCorrectAnswers;
            const userAnswerArray = answer.text ? answer.text.split("|") : [];

            if (userAnswerArray.length) {
              const similarities = await Promise.all(
                userAnswerArray.map(async (userAns) => {
                  const scores = await Promise.all(
                    arrayCorrectAnswers.map((correctAns) =>
                      compareAnswers(
                        correctAns,
                        userAns,
                        answer.bobot,
                        token,
                        mapel,
                      ),
                    ),
                  );
                  return Math.max(...scores);
                }),
              );

              similarity =
                similarities.reduce((a, b) => a + b, 0) /
                (answer.keyJawabanBenar || 1);
            }
          } else if (answer.type === "multipleChoice") {
            similarity = answer.isCorrect ? answer.bobot : 0;
          } else if (answer.type === "essay") {
            if (answer.text) {
              similarity = await compareAnswers(
                answer.correctAnswer,
                answer.text,
                answer.bobot,
                token,
                mapel,
              );
            }
          }

          return {
            ...answer,
            optionCorrectAnswer:
              answer.type === "isian" ? mappedCorrectAnswers.join("|") : "",
            score: similarity,
          };
        }),
      );

      // Kirim ke server
      await axios.post(
        `${process.env.REACT_APP_API_URL}api/answers`,
        { questionId, answers: combinedAnswers },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setSubmitted(true);
      navigate(`/siswa/elearning-siswa/${mapel}`);
    } catch (error) {
      console.error("Error submitting answer:", error);
    } finally {
      setLoading(false);
    }
  };

  const isSplitScreen = () => {
    // Rasio lebar window terhadap layar asli
    const widthRatio = window.innerWidth / window.screen.width;
    const heightRatio = window.innerHeight / window.screen.height;

    // Jika salah satu jauh lebih kecil → kemungkinan split screen
    return widthRatio < 0.9 || heightRatio < 0.9;
  };

  const isMobile = () => {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  };
  const isDesktopModeOnMobile = () => {
    const isTouch = navigator.maxTouchPoints > 0;
    const isWide = window.innerWidth >= 900; // threshold aman
    return isTouch && isWide;
  };

  const enterFullscreenAndStart = async () => {
    // ❌ Desktop mode di HP
    if (isDesktopModeOnMobile()) {
      alert(
        "❌ MODE DESKTOP TERDETEKSI\n\n" +
          "Nonaktifkan 'Desktop site' pada browser.\n" +
          "Gunakan mode mobile untuk mengikuti ujian.",
      );
      return;
    }

    // ❌ Split screen
    if (isMobile() && isSplitScreen()) {
      alert(
        "❌ MODE SPLIT SCREEN TERDETEKSI\n\n" +
          "Gunakan layar penuh untuk memulai ujian.",
      );
      return;
    }

    if (!document.documentElement.requestFullscreen) {
      alert("❌ Browser tidak mendukung fullscreen.");
      return;
    }

    try {
      await document.documentElement.requestFullscreen();
      setExamStarted(true);
    } catch {
      alert("❌ Gagal masuk fullscreen.");
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (
        examStarted &&
        !submitted &&
        (isSplitScreen() || isDesktopModeOnMobile())
      ) {
        safeSubmit("Resize terdeteksi");
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [examStarted, submitted]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (examStarted && !submitted && !document.fullscreenElement) {
        safeSubmit("Keluar fullscreen");
      }
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () =>
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, [examStarted, submitted]);

  if (!examStarted) {
    if (!localStorage.getItem("token")) {
      return null; // redirect sudah berjalan
    }
    return (
      <div className="flex min-h-screen items-center justify-center bg-blue-100 px-4">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-md">
          <h2 className="text-xl font-bold mb-4 text-red-600">⚠️ Peringatan</h2>
          <p className="mb-6">
            Layar akan otomatis <b>fullscreen</b> untuk menghindari kecurangan.
            <br />
            Tekan <b>OK</b> untuk memulai ujian.
          </p>
          <button
            onClick={enterFullscreenAndStart}
            className="bg-blue-600 hover:bg-blue-800 text-white px-6 py-2 rounded-lg"
          >
            OK
          </button>
        </div>
      </div>
    );
  }

  if (!questionData) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p>Loading soal...</p>
      </div>
    );
  }
  return (
    <div className="grid min-h-screen bg-blue-100">
      <div className="my-10 w-screen px-4">
        <div className="flex justify-center items-center my-10">
          <h2 className="font-bold text-3xl">
            {questionData.jenis} - {questionData.mapel}
          </h2>
        </div>
        <div className="flex justify-center items-center m-5">
          <div className="bg-white p-5 rounded-lg w-[400px] md:w-[600px] px-5">
            <form onSubmit={handleSubmit}>
              {questionData.question.map((q, index) => (
                <div key={q._id || index} className="mb-4">
                  <p className="text-xl mb-2 flex gap-2 ">
                    <span>{index + 1}.</span>
                    <div className="grid w-full overflow-x-auto">
                      <AutoMathText text={q.text} />
                    </div>
                  </p>

                  {q.gambar && (
                    <img
                      src={`${process.env.REACT_APP_API_URL}api/questions/image/${q.gambar.filename}`}
                      alt="Question"
                      className="mb-4 w-[400px] h-[200px] object-cover cursor-zoom-in hover:scale-105 transition"
                      onClick={() =>
                        setSelectedImage(
                          `${process.env.REACT_APP_API_URL}api/questions/image/${q.gambar.filename}`,
                        )
                      }
                    />
                  )}
                  {q.type === "multipleChoice" ? (
                    <div>
                      {q.options.map((option, idx) => (
                        <div key={idx} className="mb-2 ml-5">
                          <input
                            type="radio"
                            id={`question${index}_option${idx}`}
                            name={`question${index}`}
                            value={option.text}
                            onChange={() =>
                              handleInputChange(
                                index,
                                option.text,
                                option.isCorrect,
                              )
                            }
                            disabled={submitted}
                          />
                          <label
                            htmlFor={`question${index}_option${idx}`}
                            className="ml-2"
                          >
                            <AutoMathText text={option.text} />
                          </label>
                          {option.gambar && (
                            <img
                              src={`${process.env.REACT_APP_API_URL}api/questions/image/${option.gambar.filename}`}
                              alt="Option"
                              className="ml-2 w-[100px] h-[100px] rounded"
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  ) : q.type === "isian" ? (
                    <div>
                      <p className="mb-2">Jawaban Anda:</p>
                      {Array.from({ length: q.keyJawabanBenar }).map(
                        (_, idx) => (
                          <div key={idx} className="mb-2 flex items-center">
                            <input
                              type="text"
                              className="w-full p-2 border border-slate-500 rounded-lg"
                              value={inputValues[index]?.[idx] || ""} // Ambil nilai sesuai nomor soal dan jawaban
                              onChange={(e) =>
                                handleInputChangeIsian(
                                  index,
                                  idx,
                                  e.target.value,
                                )
                              } // Handle perubahan input
                              placeholder={`Jawaban ${idx + 1}`}
                              disabled={submitted} // Nonaktifkan jika sudah disubmit
                            />
                          </div>
                        ),
                      )}
                    </div>
                  ) : (
                    <textarea
                      className="w-full p-2 border border-slate-500 rounded-lg"
                      rows="5"
                      value={essayAnswers[index] || ""}
                      onChange={(e) => handleEssayChange(index, e.target.value)}
                      disabled={submitted}
                    />
                  )}
                </div>
              ))}

              <div className="flex justify-center mt-4 bg-blue-400 p-3 mx-20 rounded-lg font-bold hover:bg-blue-700 hover:text-white">
                {!submitted && (
                  <button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      safeSubmit();
                    }}
                  >
                    Submit Answer
                  </button>
                )}
                {submitted && (
                  <p>Anda sudah mengirimkan jawaban untuk soal ini.</p>
                )}
                <div>
                  {Hasil.map((answer) => {
                    const totalScore = answer.question.reduce((acc, q) => {
                      if (q.type === "multipleChoice") {
                        return acc + (q.isCorrect ? q.bobot : 0);
                      } else if (q.type === "essay") {
                        return acc + (q.score !== null ? q.score : 0); // TESTING YAA
                      } else if (q.type === "isian") {
                        return acc + (q.score !== null ? q.score : 0);
                      }
                      return acc;
                    }, 0);

                    return (
                      <div key={answer._id}>
                        <h2 className="grid justify-center font-bold py-4">
                          Total Nilai: {totalScore.toFixed(2)}
                          <div className="flex justify-center mb-10">
                            <Link to={`/siswa/elearning-siswa/${mapel}`}>
                              <Back />
                            </Link>
                          </div>
                        </h2>
                      </div>
                    );
                  })}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg text-center shadow-lg">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 mx-auto mb-4"></div>
            <p className="font-semibold text-lg">Mengirim jawaban...</p>
            <p className="text-sm text-gray-500">
              Mohon tunggu, jangan menutup halaman
            </p>
          </div>
        </div>
      )}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[999]"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Zoom"
            className="max-w-[90%] max-h-[90%] rounded-lg shadow-lg"
          />

          {/* Tombol close */}
          <button
            className="absolute top-5 right-5 text-white text-3xl font-bold"
            onClick={() => setSelectedImage(null)}
          >
            ✕
          </button>
        </div>
      )}
      {/* <div className="flex justify-center mb-10">
        <Link to={`/siswa/elearning-siswa/${mapel}`}>
          <Back />
        </Link>
      </div> */}
    </div>
  );
};

export default AnswerQuestion;
